import { render, staticRenderFns } from "./FormTemplateConfig.vue?vue&type=template&id=955a76ae&scoped=true&"
import script from "./FormTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./FormTemplateConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateConfig.vue?vue&type=style&index=0&id=955a76ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955a76ae",
  null
  
)

export default component.exports